module.exports = __webpack_public_path__ + "static/media/lithanLogo.79434618.jpg";